import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { appConfigsCodesApi } from '@/api/app'

/**
 * 错误码字典 Store
 */
export const useErrorCodesStore = defineStore(
  'errorCodes',
  () => {
    // 存储原始数据数组，便于持久化
    const errorCodesData = ref<Array<{ code: string; cn: string }>>([])
    const version = ref<string>('')
    const isLoading = ref<boolean>(false)

    // 计算属性：将数组转换为 Map
    const errorCodesMap = computed(() => {
      return new Map(errorCodesData.value.map((item) => [item.code, item.cn]))
    })

    /**
     * 获取错误码对应的提示语
     */
    function getErrorMessage(code: string | number): string | undefined {
      return errorCodesMap.value.get(String(code))
    }

    /**
     * 请求错误码字典
     */
    async function fetchErrorCodes() {
      if (isLoading.value) {
        return
      }

      isLoading.value = true

      try {
        const response = await appConfigsCodesApi({ ver: version.value })

        // 如果服务器返回了新数据
        if (response.data && Array.isArray(response.data.codes)) {
          // 保存原始数据（persist 插件会自动持久化）
          errorCodesData.value = response.data.codes

          // 从响应中获取新的版本号
          const newVersion = response.data.ver || Date.now().toString()
          version.value = newVersion
        }
      } catch (error) {
        console.error('Failed to fetch error codes:', error)
      } finally {
        isLoading.value = false
      }
    }

    /**
     * 清除缓存
     */
    function clearCache() {
      errorCodesData.value = []
      version.value = ''
    }

    return {
      errorCodesData,
      errorCodesMap,
      version,
      isLoading,
      getErrorMessage,
      fetchErrorCodes,
      clearCache,
    }
  },
  {
    persist: {
      storage: localStorage,
      pick: ['errorCodesData', 'version'],
    },
  },
)
